import {enumType} from 'common/enumType';

export const GoogleCloudHealthDataType = enumType({
   DICOM: 'DICOM',
   FHIR: 'FHIR',
});
